module.exports = __webpack_public_path__ + "img/home-customer-list-empty-state.9fcbcf4b.svg";